module.exports = __webpack_public_path__ + "static/media/5.1afa8102.jpg";